import { render } from "./Swiper.vue?vue&type=template&id=cfe02c90&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=ts"
export * from "./Swiper.vue?vue&type=script&lang=ts"

import "./Swiper.vue?vue&type=style&index=0&id=cfe02c90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cfe02c90"

export default script